import { motion } from "framer-motion";

const GeneralSkeleton = () => {
  return (
    <motion.div
      key="general-skeleton"
      className="w-full h-full bg-neutral-200/50 relative overflow-hidden"
      animate={{
        backgroundPosition: ["-50% 0", "200% 0"],
        transition: {
          duration: 1.5,
          repeat: Infinity,
          ease: "linear",
        },
      }}
      style={{
        backgroundImage:
          "linear-gradient(90deg, rgba(255,255,255,0) 40%, rgba(255,255,255,0.6) 50%, rgba(255,255,255,0) 60%)",
        backgroundSize: "200% 100%",
        backgroundRepeat: "no-repeat",
      }}
    />
  );
};

export default GeneralSkeleton;
